export const ProductInstanceCreatorState = {
    isSplit(state) {
        return state.isSplit;
    },
};
